<template>
  <div class="container">
    <transition name="modal fade">
      <div class="modal-mask modal-backdrop weapon_modal">
        <div class="">
          <div class="modal-wrapper">
            <div class="modal-dialogs" role="document">
              <div class="modal-content modal-xs bg-transparent">
                <div class="modal-body px-5 pb-5">
                  <div class="craft-weapon_list linear-gradient-color mb-3">
                    <a href="JavaScript:void(0)" class="btn-cross float-right close-modal"
                      @click="hideModal($event)">X</a>
                    <div class="row justify-content-center">
                      <div class="right-block p-3 linear-gradient-color">
                        <div class="scrollbar">
                          <div class="row">
                            <div class="col-md-3 col-lg-3 mb-4" v-for="(items, i) in info" :key="i">
                              <div class="craft-card weapon_card">
                                <div class="">
                                  <a href="#" class="
                                      weapon-card
                                      linear-gradient-color
                                      d-inline-block
                                      position-relative
                                    ">
                                    <div class="weapon_img">
                                      <ImgBlock :img="items.data.img" />
                                    </div>
                                    <span class="
                                        weapon_availability
                                        position-absolute
                                        color_green
                                        text-uppercase
                                      ">{{ items.data.rarity }}</span>
                                  </a>
                                  <h6 class="small-text text-center my-xl-2">
                                    {{ items.data.name }}
                                  </h6>
                                  <div class="buttons select_weapon">
                                    <button class="btn btn-stake btn-block w-100" @click="inMission(items.asset_id)">
                                      Select
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ApiService from "@/services";
import { useToast } from "vue-toastification";
import ImgBlock from "@/components/ImgBlock"
const toast = useToast();
export default {
  name: "SelectWeaponModal",
  computed: mapState(["weapons", "loaded"]),
  data() {
    return {
      isShowModal: false,
      info: null,
    };
  },
  components:{
    ImgBlock
  },
  props: ["item"],
  mounted() {
      this.info = this.weapons.filter(
        (el) => {
          const r = el.data.rarity.toLowerCase();
          if (this.item.rarity == "rare" && (r == "epic" || r == "legendary" || r == "rare")){
            return el;
          } else if (this.item.rarity == "common"){
            return el;
          } else if (this.item.rarity == "uncommon" && r!="common"){
            return el;
          } else if (this.item.rarity == "epic" && (r == "epic" || r == "legendary")){
            return el;
          } else if (this.item.rarity == "legendary" && r == "legendary"){
            return el;
          }
        }
      );
  },
  methods: {
    hideModal(e) {
      this.$emit("w-modal-hide-click", e);
    },
    getImage(hash) {
      return ApiService.getImgUrl(hash, false);
    },
    async inMission(id) {
      const data = {
        from: localStorage.getItem("wax_user"),
        to: process.env.VUE_APP_CONTRACT,
        asset_ids: [id],
        memo: `inmission:${this.item.id}`,
      };
      await ApiService.setStake(data, ((res) => {
        if (res.processed) {
          toast.success("Transaction has been made");
          setTimeout(() => {
            this.$router.go();
          }, 2000);
        }
      }), ((error) => {
        this.error = ApiService.errorFormat(error)
        toast.error(this.error);
      }));
    },
  },
};
</script>
<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4) !important;
  transition: all 0.4s ease;
}
.weapon_modal .weapon_card {
  box-shadow: 3px 2px 5px -3px #000000;
}
.modal-content {
  border: none !important;
}
.weapon_modal .craft-weapon_list {
  margin: 0 0 0 auto;
  height: 610px;
}
.weapon_modal .close-modal {
  font-family: JockeyOne !important;
  background: #e84218;
  padding: 5px 13px;
  border-radius: 5px;
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  position: relative;
  left: 10px;
}
.weapon_modal .right-block .craft-card {
  height: auto !important;
  width: 100%;
  margin: inherit;
}
.select_weapon button {
  border-radius: 5px;
  padding: 3px;
  height: 30px;
  margin: 8px 3px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: bold;
  color: var(--main-white);
  background: #4cd137;
  display: inline-block;
  width: 100%;
}

.weapon_modal .right-block .weapon-card {
  width: 100%;
  height: 100%;
}
.weapon_availability {
  font-size: 14px;
  bottom: 10px;
  left: 10px;
}
.color_green {
  color: #20cc68;
}
.color_blue {
  color: #2b4170;
}
.color_purple {
  color: #800080;
}
</style>